import moment from 'moment'

import { FormattedDateSpan } from './Styled'

const FormattedDate = ({ date, format }) => {
  let formattedDate = ''
  if (date) {
    if (typeof format !== 'undefined') {
      formattedDate = moment(date).format(format)
    } else {
      formattedDate = moment(date).fromNow()
    }
  }
  return <FormattedDateSpan>{formattedDate}</FormattedDateSpan>
}

export default FormattedDate
